import React, { KeyboardEvent } from 'react';
import { ITeaserViewProps } from '../searchresultpage.d';
import { PageViewLogDataId, SearchTelemetryAjaxCaller, SearchTelemetryData } from '../SearchTelemetryAjaxCaller';
import { ViewType } from '../../../Common/enums';
import * as helper from '../../../Common/html-helper';
import ArrowDownIcn from '../../../Assets/svg/arrow_down';
import ArticleTileGrid from '../../articleTileGrid/article-tile-grid';
import NewsLetterPromotion from '../../newsLetterPromotion/newsLetterPromotion';
import styles from './teaser-view.scss';

const TeaserView = (props: ITeaserViewProps) => {
    const salesDesignationViewList = props.articleLists.map((l) => l.articles);
    const renderNewsLetter = !(props.kiosk || props.isMobile);
    const tabNavAttribute = { focusable: true };
    const buttonText = helper.decodeHTML(props.l10n.seeAllResults);

    const getLabelText = (index: number, buttonText: string) => {
        return `${props.articleLists[index].searchString.toLowerCase()}, ${buttonText}`;
    }

    const handleTabNavigation = (event: KeyboardEvent<HTMLAnchorElement>) => {
        if (event.key === ' ') {
            event.preventDefault(); // prevent page jump
            event.currentTarget?.click();
        }
    }

    const handleTelemetry = (stm: string) => {
        if (!stm) return;
        const data = new SearchTelemetryData(
            stm,
            PageViewLogDataId.getInstance().get(), 
            props.portal,
            props.culture,
            props.magicLink
        );
        SearchTelemetryAjaxCaller.postData(data);
    }

    const getStm = (index: number) => {
        return props.articleLists[index].telemetryDataViewModel
            ? props.articleLists[index].telemetryDataViewModel.stm
            : null;
    }

    return (
        <>
            <div className={styles.teaser_suggestion_container}>
                {salesDesignationViewList.map((list, index) => {
                    return (
                        <div className={styles.teaser_suggestion} key={index}>
                            <div className={styles.teaser_suggestion_divider}>
                                <span className={styles.search_term}>
                                    {props.articleLists[index].searchString}:
                                </span>
                                <span className={styles.result_count}>
                                    {props.articleLists[index].totalResultCount + ' '}
                                    {props.articleLists[index].totalResultCount === 1
                                        ? helper.decodeHTML(props.l10n.result)
                                        : helper.decodeHTML(props.l10n.results)}
                                </span>
                                <hr className={styles.border} />
                            </div>

                            {index === 0 && renderNewsLetter && (
                                <NewsLetterPromotion isVisible={true} />
                            )}

                            <ArticleTileGrid
                                key={index}
                                currencyInformation={props.currencyInformation}
                                viewType={ViewType.TeaserSuggestion}
                                isMobile={props.isMobile}
                                culture={props.culture}
                                portal={props.portal}
                                isGlobal={false}
                                isFilterDropDownOpen={false}
                                articles={list}
                                category={null}
                                l10n={props.l10n}
                                kiosk={props.kiosk}
                                gridNumber={index}
                                globalState={props.globalState}
                                addItemOriginToPdpLink={true}
                                singleArticleView={false}
                                magicLink={props.magicLink}
                            />

                            {props.articleLists[index].alternativeTarget != null && (
                                <div className={styles.results_button_wrapper}>
                                    <a
                                        className={styles.results_button}
                                        href={props.articleLists[index].alternativeTarget}
                                        data-stm={getStm(index)}
                                        onClick={() => handleTelemetry(getStm(index))}
                                        {...tabNavAttribute}
                                        onKeyDown={(e) => handleTabNavigation(e)}
                                        aria-label={getLabelText(index, buttonText)}
                                    >
                                        <span>{buttonText}</span>
                                        <ArrowDownIcn />
                                    </a>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default TeaserView;
